<!-- 地图 -->
<style lang="stylus" scoped>
.center
  height 100%
  padding 5px
  background-size 100% 100%
.container
  position relative
  width 120px
  height 120px
  left 100px
  top 190px
.top
  position relative
  width 86px
  height 40px
  left 95px
  top 90px
  font-size 20px
  line-height 35px
  font-weight 400
  text-align right
  padding-right 5px
  color rgba(255, 255, 255, 1)
  background url('../../../../../assets/img/ljc/Shape12.png')
  background-size 100% 100%
  span
    position absolute
    left 5px
    top 5px
    width 25px
    height 22px
    background url('../../../../../assets/img/ljc/people.png')
    background-size 100% 100%
</style>
<style lang="less">
@import "../../../../../assets/font/font.css";
.center {
  .describe {
    background: url("../../../../../assets/img/yinxiao/vip.png") no-repeat;
    width: 75600/1920vw;
    height: 15700/1080vh;
    margin: 1700/1080vh auto;
    background-size: 100% 100%;
    text-align: center;
    p {
      font-size: 2400/1080vh;
      color: rgba(255, 255, 255, 1);
      line-height: 100/1080vh;
    }
    .count {
      font-size: 9000/1080vh;
      font-family: "digital";
      font-weight: 400;
      line-height: 14500/1080vh;
      color: rgba(255, 255, 255, 1);
    }
  }
  .map {
    position: relative;
    background: url("../../../../../assets/img/yinxiao/map.png");
    width: 77900/1920vw;
    height: 56800/1080vh;
    margin: 1000/1080vh auto;
    top:2000/1080vh;
    background-size: 100% 100%;
    .item3active {
      position: absolute;
      right: -800/1920vw;
      top: 15000/1080vh;
      width: 41300/1920vw;
      height: 33800/1080vh;
      .mark {
        position: absolute;
        width: 8600/1920vw;
        height: 9800/1080vh;
        background: url("../../../../../assets/img/yinxiao/mark.png");
        background-size: 100% 100%;
        z-index: 1;
        top: 20000/1080vh;
        margin: 0 auto;
        left: 0;
        right: 0;
      }
      .tip {
        position: absolute;
        width: 41300/1920vw;
        height: 23800/1080vh;
        padding: 2000/1080vh;
        color: #fff;
        background: url("../../../../../assets/img/yinxiao/tip.png");
        background-size: 100% 100%;
        margin: 0 auto;
        left: 0;
        right: 0;
        z-index: 999;
        font-size: 1600/1080vh;
        p:nth-child(1) {
          padding: 500/1080vh 2000/1920vw;
        }
        p:nth-child(2) {
          padding: 1000/1080vh 2000/1920vw;
        }
        ul {
          padding: 500/1080vh 2000/1920vw;
          li {
            line-height: 2000/1080vh;
          }
        }
      }
    }
    .item3 {
      position: absolute;
      right: 21500/1920vw;
      top: 18000/1080vh;
      .mark {
        position: absolute;
        width: 4000/1920vw;
        height: 4600/1080vh;
        background: url("../../../../../assets/img/yinxiao/moren.png");
        background-size: 100% 100%;
        z-index: 1;
        top: 20000/1080vh;
        margin: 0 auto;
        left: 0;
        right: 0;
      }
      .tip {
        display: none;
      }
    }
    .item2active {
      position: absolute;
      right: 15000/1920vw;
      top: 14000/1080vh;
      width: 41300/1920vw;
      height: 33800/1080vh;
      .mark {
        position: absolute;
        width: 8600/1920vw;
        height: 9800/1080vh;
        background: url("../../../../../assets/img/yinxiao/mark.png");
        background-size: 100% 100%;
        z-index: 1;
        top: 20000/1080vh;
        margin: 0 auto;
        left: 0;
        right: 0;
      }
      .tip {
        position: absolute;
        width: 41300/1920vw;
        height: 23800/1080vh;
        padding: 2000/1080vh;
        color: #fff;
        background: url("../../../../../assets/img/yinxiao/tip.png");
        background-size: 100% 100%;
        margin: 0 auto;
        left: 0;
        right: 0;
        z-index: 999;
        font-size: 1600/1080vh;
        p:nth-child(1) {
          padding: 500/1080vh 2000/1920vw;
        }
        p:nth-child(2) {
          padding: 1000/1080vh 2000/1920vw;
        }
        ul {
          padding: 500/1080vh 2000/1920vw;
          li {
            line-height: 2000/1080vh;
          }
        }
      }
    }
    .item2 {
      position: absolute;
      right: 34000/1920vw;
      bottom: 15000/1080vh;
      .mark {
        width: 4000/1920vw;
        height: 4600/1080vh;
        background: url("../../../../../assets/img/yinxiao/moren.png");
        background-size: 100% 100%;
        margin: 0 auto;
      }
      .tip {
        display: none;
      }
    }
    .itemactive {
      position: absolute;
      right: -4000/1920vw;
      top: -3000/1080vh;
      width: 41300/1920vw;
      height: 33800/1080vh;
      .mark {
        position: absolute;
        width: 8600/1920vw;
        height: 9800/1080vh;
        background: url("../../../../../assets/img/yinxiao/mark.png");
        background-size: 100% 100%;
        z-index: 1;
        top: 20000/1080vh;
        left: 0;
        right: 0;
        margin: 0 auto;
      }
      .tip {
        position: absolute;
        width: 41300/1920vw;
        height: 23800/1080vh;
        padding: 2000/1080vh;
        color: #fff;
        background: url("../../../../../assets/img/yinxiao/tip.png");
        background-size: 100% 100%;
        margin: 0 auto;
        left: 0;
        right: 0;
        z-index: 999;
        font-size: 1600/1080vh;
        p:nth-child(1) {
          padding: 500/1080vh 2000/1920vw;
        }
        p:nth-child(2) {
          padding: 1000/1080vh 2000/1920vw;
        }
        ul {
          padding: 500/1080vh 2000/1920vw;
          li {
            line-height: 2000/1080vh;
          }
        }
      }
    }
    .item {
      position: absolute;
      right: -5000/1920vw;
      top: 20000/1080vh;
      width: 41300/1920vw;
      height: 33800/1080vh;
      .mark {
        width: 4000/1920vw;
        height: 4600/1080vh;
        background: url("../../../../../assets/img/yinxiao/moren.png");
        background-size: 100% 100%;
        margin: 0 auto;
      }
      .tip {
        display: none;
      }
    }
  }
}

@-webkit-keyframes opac {
  from {
    opacity: 1;
    width: 0;
    height: 0;
    top: 50%;
    left: 50%;
  }
  to {
    opacity: 0;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
  }
}
.animate .w2 {
  -webkit-animation-delay: 1s;
}
.animate .w3 {
  -webkit-animation-delay: 2s;
}
.animate .w4 {
  -webkit-animation-delay: 3s;
}
.wave {
  width: 22.7rem;
  height: 22.7rem;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  margin: 0 auto;
}
.wave * {
  border: 1px solid #fff;
  position: absolute;
  border-radius: 50%;
  -webkit-animation: opac 4s infinite;
}
</style>

<template>
  <div>
    <div class="center">
      <div class="describe">
        <p>会员总人数</p>
        <countTo
          class="count"
          :startVal="0"
          :endVal="3424089"
          :duration="5000"
        ></countTo>
      </div>
      <div class="map">
        <div :class="list[0] ? 'itemactive' : 'item'">
          <div class="tip">
            <p>辽宁大连-中山广场店</p>
            <p>"大转盘"活动-进行中2019/10-20-2019/12/30</p>
            <ul>
              <li>新增会员数：7834</li>
              <li>新增公众号关注人数：2324</li>
              <li>会员复购率：30.51%，环比提升3.21%</li>
              <li>活动访问人数：16931</li>
              <li>扫码产品数：17087</li>
              <li>中奖人数：896</li>
            </ul>
          </div>
          <div class="mark"></div>
        </div>

        <div :class="list[1] ? 'item2active' : 'item2'">
          <div class="tip">
            <p>重庆-解放路店</p>
            <p>"大转盘"活动-进行中2019/11-10-2020/2/30</p>
            <ul>
              <li>新增会员数：3912</li>
              <li>新增公众号关注人数：2892</li>
              <li>会员复购率：29.56%，环比提升4.88%</li>
              <li>活动访问人数：9768</li>
              <li>扫码产品数：10231</li>
              <li>中奖人数：5435</li>
            </ul>
          </div>
          <div class="mark"></div>
        </div>

        <div :class="list[2] ? 'item3active' : 'item3'">
          <div class="tip">
            <p>浙江杭州-西湖店</p>
            <p>"微信红包"活动-进行中 2019/10-25-2019/12/15</p>
            <ul>
              <li>新增会员数：6323</li>
              <li>新增公众号关注人数：3421</li>
              <li>会员复购率：25.24%，环比提升5.67%</li>
              <li>活动访问人数：13242</li>
              <li>扫码产品数：13532</li>
              <li>中奖人数：543</li>
            </ul>
          </div>
          <div class="mark"></div>
        </div>
      </div>
      <div class="animate wave">
        <div class="w1"></div>
        <div class="w2"></div>
        <div class="w3"></div>
        <div class="w4"></div>
      </div>
      <centerBottom></centerBottom>
    </div>
  </div>
</template>

<script>
import countTo from "vue-count-to";
import config from "../../../../../../static/config/config";
import centerBottom from "./centerBottom";
import table1 from "../table1/index";
import table2 from "../table2/index";

export default {
  props: ["productionScale", "outputValue"],
  data() {
    return {
      areaName: "",
      list: [false, false, true],
      timer: null,
      massifList: [],
      massifListR: [],
      tip: true,
      datalist: [],
      typeindex: 0,
      url: config.fileDomain
    };
  },
  components: {
    centerBottom,
    countTo,
    "v-table1": table1,
    "v-table2": table2
  },
  methods: {},
  async mounted() {
    this.time = setInterval(() => {
      this.typeindex = this.typeindex + 1;
      this.list.push(this.list.shift());
    }, 5000);
  },
  beforeDestroy() {}
};
</script>



// WEBPACK FOOTER //
// index.vue?125bda2e